import React from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import logoIcon from "@/assets/regard-de-nature-logo.png";
import { FileText } from "lucide-react";
import { BRAND } from "@/config/brand";

export const TermsOfService = () => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className="hover:text-primary transition-colors text-left">CGU</button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-2xl">
        <SheetHeader className="space-y-4 pb-6 border-b">
          <div className="flex flex-col items-center gap-3">
            <img src={logoIcon} alt={BRAND.name.full} className="w-16 h-16" />
            <div className="text-center">
              <SheetTitle className="text-3xl font-cinzel text-primary">{BRAND.name.full}</SheetTitle>
              <p className="text-sm font-montserrat font-semibold text-secondary uppercase tracking-wider mt-1">
                {BRAND.baseline.full}
              </p>
            </div>
          </div>
          <SheetDescription className="text-center text-lg font-medium text-foreground flex items-center justify-center gap-2">
            <FileText className="w-5 h-5 text-primary" />
            Conditions Générales d'Utilisation
          </SheetDescription>
        </SheetHeader>

        <ScrollArea className="h-[calc(100vh-220px)] mt-6 pr-4">
          <div className="space-y-6 text-sm">
            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">1. OBJET</h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et
                  conditions d'utilisation des services proposés par {BRAND.name.full} – {BRAND.baseline.full},
                  Praticienne en Santé Naturelle, ainsi que les droits et obligations des parties dans ce cadre.
                </p>
                <p>
                  Tout accès et/ou utilisation du site suppose l'acceptation et le respect de l'ensemble des termes des
                  présentes conditions et leur acceptation inconditionnelle.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                2. SERVICES PROPOSÉS
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  {BRAND.name.full} – {BRAND.baseline.full} propose des prestations de bien-être et d'accompagnement en
                  tant que Praticienne en Santé Naturelle, incluant notamment :
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Conseils en naturopathie</li>
                  <li>Bilans iridologiques</li>
                  <li>Formations et stages</li>
                </ul>
                <p className="font-medium text-foreground mt-2">
                  Ces prestations ne constituent en aucun cas un acte médical et ne se substituent pas à un suivi
                  médical.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                3. PRISE DE RENDEZ-VOUS
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>Les rendez-vous peuvent être pris via l'agenda en ligne depuis le site.</p>
                <p>
                  La confirmation du rendez-vous se fait par retour d'email et/ou message. Le client s'engage à
                  respecter l'horaire convenu.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                4. POLITIQUE D'ANNULATION ET DE REPORT
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p className="font-medium text-foreground">
                  Toute séance annulée ou reportée moins de 48 heures avant l'heure du rendez-vous sera due dans son
                  intégralité.
                </p>
                <p>
                  Cette politique est mise en place afin de respecter l'organisation du planning et le temps réservé
                  spécifiquement pour chaque client.
                </p>
                <p>
                  En cas d'empêchement, il est demandé au client de prévenir dans les meilleurs délais et au minimum 48
                  heures avant le rendez-vous prévu :
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Par téléphone au 06 07 08 09 10</li>
                  <li>Par email à contact@regard-de-nature.fr</li>
                </ul>
                <p>
                  En cas d'annulation dans les délais, le rendez-vous pourra être reporté sans frais supplémentaires,
                  sous réserve de disponibilité.
                </p>
                <p>
                  Les cas de force majeure (hospitalisation, accident grave) seront étudiés au cas par cas sur
                  présentation d'un justificatif.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                5. TARIFS ET MODALITÉS DE PAIEMENT
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Les tarifs des prestations sont indiqués sur le site et peuvent être modifiés à tout moment. Les
                  tarifs applicables sont ceux en vigueur au moment de la prise de rendez-vous.
                </p>
                <p>Le règlement des séances s'effectue par :</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Espèces</li>
                  <li>Chèques</li>
                  <li>Virement bancaire</li>
                </ul>
                <p>Le paiement des séances au cabinet est dû à l'issue de la séance, sauf arrangement préalable.</p>
                <p className="font-medium text-foreground">
                  Le paiement des séances en visio est dû au moment de la RESERVATION.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                6. CONTRE-INDICATIONS ET RESPONSABILITÉ
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Le client s'engage à informer le praticien de tout problème de santé, traitement médical en cours, ou
                  contre-indication avant la séance.
                </p>
                <p className="font-medium text-foreground">
                  Les techniques proposées ne se substituent en aucun cas à un traitement médical. En cas de pathologie,
                  un avis médical est indispensable.
                </p>
                <p>
                  Le praticien décline toute responsabilité en cas de non-respect de ces recommandations ou de
                  déclaration inexacte du client.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                7. CONFIDENTIALITÉ
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Le praticien s'engage à respecter la confidentialité de toutes les informations communiquées par le
                  client lors des séances, dans le respect du secret professionnel.
                </p>
                <p>
                  Les données personnelles collectées sont utilisées uniquement dans le cadre de la relation client et
                  ne sont en aucun cas transmises à des tiers.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                8. PROPRIÉTÉ INTELLECTUELLE
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  L'ensemble des contenus présents sur le site (textes, images, vidéos, logos) sont la propriété
                  exclusive de {BRAND.name.full} – {BRAND.baseline.full} ou font l'objet d'une autorisation
                  d'utilisation.
                </p>
                <p>
                  Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des
                  éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite
                  préalable.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                9. MODIFICATION DES CGU
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Les présentes CGU peuvent être modifiées à tout moment. Les nouvelles conditions seront applicables
                  dès leur mise en ligne sur le site.
                </p>
                <p>
                  Il est recommandé aux utilisateurs de consulter régulièrement les CGU pour prendre connaissance des
                  éventuelles modifications.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                10. DROIT APPLICABLE ET JURIDICTION
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  Les présentes CGU sont régies par le droit français. En cas de litige, et à défaut d'accord amiable,
                  le tribunal compétent sera celui du ressort du siège social du praticien.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">CONTACT</h3>
              <div className="space-y-2 text-muted-foreground">
                <p>Pour toute question relative aux présentes CGU :</p>
                <p className="font-medium text-foreground">
                  {BRAND.name.full} – {BRAND.baseline.full}
                </p>
                <p>28-30 rue de la République – 31290 Villefranche-de-Lauraguet</p>
                <p>Téléphone : 06 07 08 09 10</p>
                <p>Email : contact@regard-de-nature.fr</p>
              </div>
            </section>
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
